<script>
import Endpoints from '../../../components/common/Endpoints'
import Common from '../../../components/common/Common'
import Request from '../../../components/common/Request'
import { mapActions } from 'vuex'
import { stat } from 'fs'

export default {
    init: async payload => {
        const el = document.body
        el.removeAttribute('class')

        payload.domain = Endpoints.domain
        await payload.getCompanies()
    },
    methods: {
        createBankSlip: async function () {
            $('#spinner').modal('toggle')
            let data = JSON.parse(JSON.stringify(this.company))
            data.company = data._id
            delete data._id

            Request.do(
                this,
                'POST',
                Request.getDefaultHeader(this),
                data,
                `${Endpoints.bankSlips.generateBankSlipAdmin}`,
                response => {
                    //SUCCESS CALLBACK
                    $('#spinner').modal('toggle')
                    this.filter()
                },
                error => {
                    //ERROR CALLBACK
                    $('#spinner').modal('toggle')
                },
            )
        },
        emailModal: function () {
            this.titleToast = this.$t('string.msg.confirm')
            this.messageToast = this.$t('str.msg.confirm.email.label')
            this.cancelText = this.$t('string.msg.cancel')
            this.yesText = this.$t('string.msg.yes')

            //ENVIA PRA MODAL O EMAIL E VALOR
            this.email = this.company.email
            this.total = Number(14.9).toFixed(2)

            $('#modalEmail').modal('show')
        },
        validateEmail: function (email) {
            const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
            return re.test(String(email).toLowerCase())
        },
        returnModal: function (response) {
            response.total = response.total.toString().split('.').join('').split(',').join('.').split('R$ ').join('')
            if (response && response != 0 && this.validateEmail(response.email) && response.total > 0) {
                this.company.email = response.email
                this.company.total = Number(response.total)
                this.company.dueDate = response.dueDate
                this.createBankSlip()
            }
        },
        getCompanies: async function () {
            let state = this
            state.companies = []
            $('#spinner').modal('toggle')
            await Request.do(
                state,
                'GET',
                Request.getDefaultHeader(state),
                null,
                `${Endpoints.companies.listActivies}`,
                response => {
                    //SUCCESS CALLBACK
                    state.companies = response.results
                    $('#spinner').modal('toggle')
                },
                error => {
                    //ERROR CALLBACK
                },
            )
        },
        isCheckDate: function (date) {
            if (date) {
                let dueDate = new Date(date)
                let currentDate = new Date()
                dueDate.setHours(0, 0, 0, 0)
                currentDate.setHours(0, 0, 0, 0)

                if (currentDate <= dueDate) {
                    return true
                } else {
                    return null
                }
            } else {
                return null
            }
        },
        checkBankSlipInMonth: function (items) {
            let month = new Date().getMonth() + 1
            let year = new Date().getUTCFullYear()

            let index = items.findIndex(item => item.month == String(month) && String(item.year) == year)
            if (index == -1) {
                this.hasBankSlipInMonth = false
            } else {
                this.hasBankSlipInMonth = true
            }
        },
        filter: async function () {
            let state = this
            state.items = []
            state.hasBankSlipInMonth = false

            let filters = state.filters

            if (state.company) {
                filters.company = state.company._id
            } else {
                delete filters.company
            }

            if (!filters.status) {
                delete filters.status
            }

            await Request.do(
                state,
                'POST',
                Request.getDefaultHeader(state),
                filters,
                `${Endpoints.bankSlips.getByCompany}`,
                async response => {
                    //SUCCESS CALLBACK
                    state.items = response.results
                    if (response.results.length > 0 && state.company) {
                        await state.checkBankSlipInMonth(state.items)
                    }
                },
                error => {
                    //ERROR CALLBACK
                },
            )
        },
        customLabelCompany(option) {
            return this.toUpperCase(`${option.fantasyName + ' - ' + option.document}`)
        },
        checkForm: function (e) {
            this.errors = []
            let document = String(this.company.document).replace(/\//g, '').replace(/\./g, '').replace(/\-/g, '')
            if (document.length != 14) {
                this.errors.push(this.$t('response.cnpj.register.invalid'))
            }

            if (this.errors.length > 0) {
                e.preventDefault()
            } else {
                this.emailModal()
            }
        },
        onChange: function () {},
        onChangePage(pageOfItems) {
            // update page of items
            this.pageOfItems = pageOfItems
        },
        getPageNumbers: function () {
            return this.items.length / 10
        },
        fetchData() {
            this.json_data = this.items
            return this.json_data
        },
        camelize: Common.camelize,
        toUpperCase: Common.toUpperCase,
    },
}
</script>
